"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Ansichten-Listen-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCViews
 * @author Anton Popov <a.popov@brain-scc.de>
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCViews} options.module Modulinstanz
 */
gc.gis.module.GCViews.ListPanel = function( options )
{
	var self = this;

	gc.gis.assert.isSet( options );
	gc.gis.assert.isInstance( options.module, gc.gis.module.GCViews );

	this.module = options.module;
	this.loading_queue = 0;
	this.filter_re = new RegExp('()', 'gi');


	var options_widget = {
		className: 'gc-views',
		toolbar: new gc.gis.widget.GCWidgetGroup({
			items: this._createToolbarWidgets()
		})
	};

	gc.gis.widget.GCPanel.call(this, options_widget);

	this.element = this._render();

	this._initContent();

	this.module.on( gc.gis.module.GCViewsEvent.VIEW_LOADING_STARTED, this, function( evt ) {
		self.onLoadingStarted( evt );
	});
	this.module.on( gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, this, function( evt ) {
		self.onLoadingStopped( evt );
	});
};
gc.gis.module.GCViews.ListPanel.prototype = Object.create( gc.gis.widget.GCPanel.prototype );

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype._initContent = function()
{
	var element_list = this._initList();

	this.element_content.append(element_list);

	this.element_loading = jQuery('<div>', {
		'class': 'gc-views-loading'
	});
	this.element_content.append( this.element_loading );
};

/**
 * @protected
 * @method
 *
 * @return {gc.gis.widget.GCWidget[]}
 */
gc.gis.module.GCViews.ListPanel.prototype._createToolbarWidgets = function()
{
	var self = this;

	return [
			new gc.gis.widget.GCSearch({
				keyup: function(value) {
					self.setFilter(value);
				},
				reset: function () {
					this.reset();
					self.setFilter('');
				}
			})
		];
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype._initList = function()
{
	// Liste
	this.element_list = jQuery('<ul>');

	var element_list_content = jQuery('<div>', {
		'class': 'gc-views-list-content',
		html: this.element_list
	});

	// Container
	var element_list_container = jQuery('<div>', {
		'class': 'gc-views-list'
	});
	element_list_container.append(element_list_content);

	return element_list_container;
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype.setFilter = function(filter)
{
	this.filter_re = new RegExp('('+filter+')', 'gi');

	this.updateList( this.module.getViews() );
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype._filterViews = function(views)
{
	var filtered_views = [];
	var i;

	if( this.filter === '' )
	{
		for(i=0; i<views.length; i++ )
		{
			if( views[i].element )
			{
				views[i].element.find('.gc-views-view-label').html(
					views[i].name
				);
			}
		}
		filtered_views = views;
	}
	else
	{
		for(i=0; i<views.length; i++ )
		{
			var match = this.filter_re.test( views[i].name );
			if( match )
			{
				if( views[i].element )
				{
					views[i].element.find('.gc-views-view-label').html(
						views[i].name.replace(
							this.filter_re,
							'<strong class="gc-highlight">$1</strong>'
						)
					);
				}
				filtered_views.push( views[i] );
			}
		}
	}

	return filtered_views;
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype.updateList = function(views)
{
	this.views = views;
	views = this._filterViews( views );
	this.element_list.children().detach();

	for( var i=0; i<views.length; i++ )
	{
		var li;
		var element = views[i].element;
		if( element )
		{
			li = element.parent();
		}
		else
		{
			li = this._createListItem( views[i] );
		}

		this.element_list.append(li);
	}

	this._setListItemActive( this.module.getSelectedView() );
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype._createListItem = function(view)
{
	view.name = view.name ? view.name : 'Unbenannt';

	var self = this;
	var label_text = view.name.replace(
		this.filter_re,
		'<strong class="highlight">$1</strong>'
	);
	var label = jQuery('<span>', {
		'class': 'gc-views-view-label',
		html: label_text
	});

	var element_states = jQuery('<span>', {
		'class': 'gc-views-states'
	});

	if( view.states )
	{
		var state_count = 0;
		var keys = Object.keys( view.states );
		for( var j=0; j<keys.length; j++ )
		{
			var state = keys[j];

			if( state === 'readonly' || state === 'readwrite' )
			{
				continue;
			}

			if( j>0 )
			{
				element_states.append( jQuery('<span>', {'class':'hidden',text:', '}) );
			}
			else
			{
				element_states.append( jQuery('<span>', {'class':'hidden',text:'('}) );
			}
			element_states.append( jQuery('<span>', {
				'class': 'gc-views-state gc-views-state-'+ state +' '+ self._stateToIcon( state ),
				title:   self._stateToText( state ),
				html:    '<span>'+ self._stateToText( state ) +'</span>'
			}) );
			state_count++;
		}
		if( state_count > 0 )
		{
			element_states.append( jQuery('<span>', {'class':'hidden',text:')'}) );
		}
	}

	var button = gc.gis.iface.ui.sidebar.createSubmenuItem({
		label: label,
		click: function( evt ) {
			evt.preventDefault();
			try
			{
				if (!jQuery(this).is('.active')) {
					self.module.setSelectedView(view);
					self._setListItemActive(view);
				}
				else {
					self.module.setSelectedView(undefined);
					self._setListItemActive(undefined);
				}
			}
			catch( err )
			{
				gc.gis.iface.log.error( self, err );
			}
			jQuery(this).blur();
		}
	});
	button.append(' ').append( element_states );

	var li = jQuery('<li>', {
		html: button
	});

	view.element = button;

	return li;
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype._setListItemActive = function(view)
{
	for( var i=0; i<this.views.length; i++ )
	{
		if( this.views[i].element )
		{
			this.views[i].element.removeClass('active');
		}
	}
	if( view && view.element )
	{
		view.element.addClass('active');
	}
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype._stateToText = function(state)
{
	var dict = {
		'own':     'eigene Ansicht',
		'default': 'Startansicht',
		'foreign': 'freigegebene Ansicht'
	};
	return dict[state] || state;
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype._stateToIcon = function(state)
{
	var dict = {
		'own':     'glyphicon glyphicon-user',
		'default': 'glyphicon glyphicon-home',
		'foreign': 'glyphicon glyphicon-paperclip'
	};
	return dict[state] || state;
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype.onLoadingStarted = function()
{
	if( this.loading_queue === 0 )
	{
		this.element_loading.show('fade');
	}
	this.loading_queue++;
};

/**
 *
 */
gc.gis.module.GCViews.ListPanel.prototype.onLoadingStopped = function()
{
	var self = this;

	this.loading_queue--;

	if( this.loading_queue === 0 )
	{
		this.element_loading.hide('fade');
		self.updateList( self.module.getViews() );
	}
};
